import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-btc-cashin-form',
  templateUrl: './btc-cashin-form.component.html',
  // Mantiene el layout del formulario en el grid declarado por el padre.
  styles: [':host { display: contents; }'],
})
export class BtcCashinFormComponent {
  @Input() ctx!: any;
}
